import { Box, TextField } from '@mui/material';
import { Field, FieldProps, useFormikContext } from 'formik';
import { Terminal } from 'modules/global/adapters/crpAPI';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { errorMessage } from 'store/actions/messageActions';
import store from 'store/store';
import useStyles from '../shared/styles';
import IdentificationSelectAutoComplete from 'modules/global/components/IdentificationSelectAutoComplete/IdentificationSelectAutoComplete';
import { LABEL } from 'theme/constants';
import { Autocomplete } from '@mui/material';

type Props = {
  terminals: Terminal[] | undefined;
  terminalNxtEntityIdError: string | undefined;
  isLoadingError: boolean;
  isFetching: boolean;
};

const SearchStep = ({ terminals, terminalNxtEntityIdError, isLoadingError, isFetching }: Props) => {
  const { t } = useTranslation(['glossary', 'useCase']);
  const { classes } = useStyles();

  const { setFieldValue } = useFormikContext();

  const terminalNxtEntityIdHasError = Boolean(terminalNxtEntityIdError);

  useEffect(() => {
    isLoadingError &&
      store.dispatch(errorMessage(t('messages.errorGetTransferReleaseRightFilterData')));
  }, [isLoadingError, t]);

  useEffect(() => {
    setFieldValue('identificationCode', '');
  }, [setFieldValue]);

  return (
    <>
      <Box marginTop={2}>
        <Field name="equipmentNumber" id="equipmentNumber">
          {({ field }: FieldProps) => (
            <TextField {...field} variant="outlined" label={t('equipmentNumber')} fullWidth />
          )}
        </Field>
      </Box>
      <Box marginTop={2}>
        <Field name="billOfLadingNumber" id="billOfLadingNumber">
          {({ field }: FieldProps) => (
            <TextField {...field} variant="outlined" label={t('billOfLadingNumber')} fullWidth />
          )}
        </Field>
      </Box>

      <Box marginTop={2}>
        <Field name="terminalNxtEntityId" id="terminalNxtEntityId">
          {({ field, form }: FieldProps) => (
            <Autocomplete
              id="inpTerminalCode"
              options={terminals || []}
              getOptionLabel={(terminal: Terminal) =>
                `${terminal.name} (${terminal.portLoCode} ${terminal.code})`
              }
              value={terminals?.find((t) => t.nxtEntityId === field.value) || null}
              onChange={(_, value) => {
                form.setFieldValue('terminalNxtEntityId', value ? value.nxtEntityId : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={LABEL.CHOOSE_TERMINAL}
                  fullWidth
                  error={terminalNxtEntityIdHasError}
                  helperText={terminalNxtEntityIdHasError ? terminalNxtEntityIdError : ''}
                  variant="outlined"
                />
              )}
              fullWidth
              getOptionDisabled={() => isFetching}
              disabled={isFetching}
            />
          )}
        </Field>
      </Box>

      <Box marginTop={2}>
        <IdentificationSelectAutoComplete
          showText={false}
          label={LABEL.RECEIVED_FROM}
          translationKey="transferReleaseRight"
          textLabel={undefined}
          roles={[LABEL.SHIPPING_AGENT, LABEL.TRANSPORT_OPERATOR, LABEL.RELEASE_PARTY]}
        />
      </Box>
    </>
  );
};
export default SearchStep;
